import {
  BALL_CODE,
  CANVAS_CANONICAL,
  CANVAS_MAIN,
  CANVAS_SECOND,
  PLAYER_CODE,
  PLAYER_NUMBER,
  PLAYERS_ALL_CODE,
  TRACK_ID,
  VIEW_FRAMES,
} from '@/constants';

export const getDefaultField = () => {
  return {
    id: null,
    points: [],
    pointsCanonical: [],
    showLabel: false,
  }
};

export const getDefaultState = () => {
  return {
    action: 'default', // ['default', 'addObject']
    currentFrame: 10,
    event: {},
    eventTypes: [],
    events: {
      filters: {
        search: '',
        type: '',
      },
      items: {},
      limit: 50,
      loading: false,
      page: 1,
      total: 0,
    },
    eventsNew: [],
    logs: {
      items: [],
      loop: null,
      loading: false,
    },
    self: {},

    teams: null,
    kits: [],

    selectedObject: null,
    detects: [],
    detectCurrent: null,
    detectsFiltered: [],
    field: getDefaultField(),
    filters: {
      detectLabels: [PLAYER_NUMBER, TRACK_ID],
      detectTypes: [BALL_CODE, PLAYERS_ALL_CODE, PLAYER_CODE],
      interpolated: false,
      lineups: false,
      showSelectedDetect: [],
    },
    prevNewDetect: null,

    [CANVAS_MAIN]: {
      img: null,
      loading: [],
      size: {
        height: 0,
        width: 0,
      },
      visible: true,
    },
    [CANVAS_SECOND]: {
      img: null,
      loading: [],
      size: {
        height: 0,
        width: 0,
      },
      visible: false,
    },
    [CANVAS_CANONICAL]: {
      img: null,
      loading: [],
      size: {
        height: 0,
        width: 0,
      },
      visible: false,
    },

    statistic: {
      frame: {},
      game: {
        loading: false,
        table: [],
        team_a: {},
        team_b: {},
      },
      players: {
        items: [],
        loading: false,
      },
      showTeamShapes: false,
    },

    view: VIEW_FRAMES,
  }
};

export default getDefaultState();
